import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ErrorType } from "@/shared/types";
import { fetchTradingFoundations } from "./social-market-foundations-thunk";
import { SocialMarketFoundationsState } from "./types";

const initialState: SocialMarketFoundationsState = {
    partners: [],
    isLoading: false,
    isFirstLoad: true,
    partnersError: null,
    searchQuery: null
}

const socialMarketFoundationsSlice = createSlice({
    name: 'socialMarketPartners',
    initialState,
    reducers: {
        setSearchQuery: (state, action: PayloadAction<string>) => {
            state.searchQuery = action.payload || null
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchTradingFoundations.pending, (state) => {
            state.isLoading = false
        })
        .addCase(fetchTradingFoundations.fulfilled, (state, action) => {
            state.isFirstLoad = false
            state.partnersError = null
            state.partners = action.payload
            state.isLoading = false
        })
        .addCase(fetchTradingFoundations.rejected, (state, action) => {
            state.partnersError = action.payload as ErrorType ?? null
            state.isLoading = false
        })
    },
})

export default socialMarketFoundationsSlice.reducer
export const { setSearchQuery } = socialMarketFoundationsSlice.actions